export default function TimeHighlight() {
  return (
    <section className="bg-yellow-500 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-center">
          <div className="w-20 h-20 flex items-center justify-center">
            <i className="ri-timer-flash-line text-6xl text-black"></i>
          </div>
          <div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-black mb-2">
              GUINCHO A 10 MINUTOS DE VOCÊ
            </h2>
            <p className="text-lg text-black/80 font-medium">
              Frota estrategicamente posicionada para atendimento rápido em todo o Brasil
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}